import * as React from 'react'

/**
 * Returns `refIsMounted`, that contains the information whether the component is currently mounted.
 * Use it as a condition when you need to asynchronously update a state of the component
 * `if (refIsMounted.current){ ...it is safe to update the state... }`
 * It is important to use this hook as soon as possible at the top of the component.
 */
export const useIsMountedRef = () => {
  const refIsMounted = React.useRef(false)

  // you could use useLayoutEffect to run as soon as possible,
  // but with SSR, you will get the warning:
  //  "useLayoutEffect does nothing on the server, because its effect cannot be encoded into the server renderer's output format.
  //  This will lead to a mismatch between the initial, non-hydrated UI and the intended UI.
  //  To avoid this, useLayoutEffect should only be used in components that render exclusively on the client.
  //  See https://reactjs.org/link/uselayouteffect-ssr for common fixes."

  React.useEffect(() => {
    refIsMounted.current = true

    return () => {
      refIsMounted.current = false
    }
  }, [])

  return refIsMounted
}
